import React, { useEffect, useState } from 'react';

const About = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(false);
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="container my-5">
      <h1 className="mb-4">About Us</h1>

      <p>
        <strong>Vegbox GmbH</strong> is a modern gastronomy company based in Duebendorf. 
        Our mission is to create high-quality culinary experiences while offering a space for 
        hospitality and human connection.
      </p>

      <h2 className="mt-5">Our Philosophy</h2>
      <p>
        We believe in quality, sustainability, and authenticity. Our dishes are prepared using 
        fresh, seasonal ingredients, sourced locally whenever possible. We place great value on 
        craftsmanship, creativity, and attention to detail.
      </p>

      <h2 className="mt-5">Our Team</h2>
      <p>
        Behind every dish is a passionate team of chefs, hosts, and service professionals. 
        Together, we strive to provide guests with unforgettable experiences—whether it's a quick lunch, 
        a relaxed dinner, or a private event.
      </p>

      <h2 className="mt-5">Contact</h2>
      <p>
        Have questions or want to learn more about us?<br />
        Call us at <strong>+41782224236</strong> or email us at <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a>.
      </p>

      <p className="mt-4"><em>Duebendorf, January 2025</em></p>
    </div>
  );
};

export default About;
